import React from "react";

type Props = { size?: number };

export default function CoinSVG({ size = 24 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`h-${size} w-${size}`}
      viewBox="0 0 24 24"
    >
      <g fill="none" stroke="currentColor" strokeWidth="2">
        <ellipse
          cx="9.5"
          cy="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          rx="9.5"
          ry="10"
          transform="matrix(-1 0 0 1 20 2)"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 8.8a3.583 3.583 0 0 0-2.25-.8C8.679 8 7 9.79 7 12s1.679 4 3.75 4c.844 0 1.623-.298 2.25-.8"
        />
        <path d="M10 2c4.333 0 13 1 13 10s-8.667 10-13 10" />
      </g>
    </svg>
  );
}
